<script setup lang="ts">
import type { KjdsListPageProps } from '@/types/appTypes'

const props = withDefaults(defineProps<KjdsListPageProps>(), {})

console.log('article: kjdsPageConfig', props.kjdsPageConfig)

const app = useNuxtApp()
const storeArticleList = useStoreArticleList()
const storeIndex = useStoreIndex()

const baseTitle = 'ニュース'
const headTitle = baseTitle

const pageData = {
  tags: [] as ArticleTag[],
  items: [] as Article[],
  meta: {} as ApiMeta,
}

const setHead = () => {
  let headDescription = ''
  let items = []
  headDescription = `美術館・博物館・ミュージアムやアートのニュースをいち早くお届け！　実際に現場で取材したニュースを、美しい写真とともにお送りします。美術館・博物館・アートのニュースはアイエムで！`
  items = [
    {
      text: headTitle,
      disabled: true,
    },
  ]
  storeIndex.setBreadCrumbs(items)

  const headInput = app.$makeMeta({
    title: headTitle,
    description: headDescription,
  })
  useHead(headInput)
}

const initPage = async () => {
  const options: KjdsFetchListOptions = { query: { ...useRoute().query } }
  const [resSite, resMaster, resList] = await Promise.all([
    storeIndex.fetchSite(),
    storeIndex.fetchMaster(),
    storeArticleList.fetchList(props.kjdsPageConfig.list.mainListName, options),
  ])
  pageData.items = resList.data.articles as Article[]
  pageData.meta = resList.meta

  console.log('article: initPage', pageData)
}
await initPage()
setHead()
</script>

<template>
  <div class="p-articlePage">
    <h2 class="c-heading_page">
      ニュース
    </h2>

    <div class="p-articlePage_result">
      <div
        class="c-listHeader"
      >
        <div class="c-listHeader_col">
          <div class="c-listHeader_col_contentSearch">
            全 {{ pageData.meta.count.toLocaleString() }}件
          </div>
        </div>
      </div>

      <div class="p-articlePage_list">
        <NewsItem
          v-for="item in pageData.items"
          v-bind:key="item.id"
          v-bind:item="item"
        />
      </div>

      <Pagination
        v-bind:page="pageData.meta.page_no"
        v-bind:length="pageData.meta.total_page"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.c-searchSort {
  margin-top: 0 !important;
  border: 1px solid var(--g_color_border_gray);
}
</style>
